import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './portfolio.css';
import { Link } from 'react-router-dom';

const categories = [
  {
    title: 'Brand & Product Content',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918879/cover1_ka1rpg.jpg',
    path: '/portfolio/brandcontent',
  },
  {
    title: 'Fashion',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1749263992/cover2_lwmnc4.jpg',
    path: '/portfolio/fashion',
  },
  {
    title: 'My Aesthetic',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1750977382/cover5_rx9po4.jpg',
    path: '/portfolio/myaesthetic',
  },
  {
    title: 'Self Care & Makeup',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1750635274/cover3_r7eozz.jpg',
    path: '/portfolio/selfcaremakeup',
  },
];


function Portfolio() {
    return (
<div className="containerPortfolio">
  <div className='textPortfolio'>
    <span className='titlePortfolio'>Where Heart Meets Vision</span> <br/>
    <span>Welcome to my portfolio. Here you’ll find a curated collection of the content I’ve created across different styles and platforms — from short-form videos and brand collaborations to personal photo shoots and aesthetic edits. Every category reflects a part of my creative journey, captured through my lens and shaped by my vision.</span>
  </div>
  <div className="category-grid">
        {categories.map((category, index) => (
          <Link to={category.path} key={index} className="category-card">
            <img src={category.image} alt={category.title} className="category-image" />
            <div className="category-overlay">
              <h2 className="category-title">{category.title}</h2>
            </div>
          </Link>
        ))}
      </div>
      
    </div>
  );
}
  
  export default Portfolio;